import {AwsRum} from 'aws-rum-web';

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace NodeJS {
        interface ProcessEnv {
            NEXT_PUBLIC_RUM_APPLICATION_ID?: string;
            NEXT_PUBLIC_RUM_IDENTITY_POOL_ID?: string;
        }
    }
}

let _awsRum: AwsRum | undefined;

if (process.env.NEXT_PUBLIC_RUM_APPLICATION_ID) {
    try {
        _awsRum = new AwsRum(process.env.NEXT_PUBLIC_RUM_APPLICATION_ID, '1.0.0', 'us-west-1', {
            sessionSampleRate: 1.0,
            endpoint: 'https://dataplane.rum.us-west-1.amazonaws.com',
            telemetries: ['http', 'errors', 'performance'],
            allowCookies: true,
            enableXRay: true,
            identityPoolId: process.env.NEXT_PUBLIC_RUM_IDENTITY_POOL_ID,
        });
        console.info('Rum initialized');
    } catch (e) {
        console.error('Rum failed to initialize', e);
    }
} else {
    console.warn('Rum not initialized due to missing RUM_APPLICATION_ID');
}

export const awsRum = _awsRum;
